'use strict';

const $ = require('dibs-jquery-shim');
const BaseStore = require('fluxible/addons/BaseStore');
const ItemStore = require('./ItemStore');
const buyerAssurance = require('../../../../json/copy/buyerAssurance');
const loginActions = require('../../global/actions/loginActions.es');
const verticalHelpers = require('dibs-vertical-helpers');
const pdpActionsConstants = require('../actions/pdpActionsConstants.es.js');

require('bunsen/libraries/plugins/jquery.cookie');

class PdpUiStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.itemStore = dispatcher.getStore(ItemStore);
        this.heroCarouselIndex = 0;
        this.heroExpanded = false;
        this.justAuthenticatedFromQuoteRequest = false;
        this.quoteRequestInitiatedFrom = null;
        this.isPinterestModalShown = false;

        this.buyerAssuranceProps = {
            copy: buyerAssurance || {},
            state: {
                showInfo: false,
            },
        };

        const vertical = this.itemStore.getFromItemModel('vertical');
        this.isNetPriceVertical = vertical === verticalHelpers.VERTICAL_FURNITURE;
        this.enableRequestNetPrice = false;
        this.forceFavoriteItem = false;
    }

    getHeroCarouselIndex() {
        return this.heroCarouselIndex;
    }

    onChangeIndex({ index }) {
        this.heroCarouselIndex = index;
        this.emitChange();
    }

    getHeroExpanded() {
        return this.heroExpanded;
    }

    onHeroExpanded({ heroExpanded }) {
        this.heroChangingSize = true;
        this.heroExpanded = heroExpanded;
        this.emitChange();
    }

    onShippingRequestAuthenticated({ parentComponentName }) {
        this.justAuthenticatedFromQuoteRequest = true;
        this.quoteRequestInitiatedFrom = parentComponentName;
    }

    onShippingRequestCompleted() {
        this.justAuthenticatedFromQuoteRequest = false;
        this.quoteRequestInitiatedFrom = null;
    }

    isJustAuthenticatedFromQuoteRequest() {
        return this.justAuthenticatedFromQuoteRequest;
    }

    getQuoteRequestInitiatedFromName() {
        return this.quoteRequestInitiatedFrom;
    }

    setPrintPage({ isPrintPage, isPrintNP }) {
        this.isPrintPage = isPrintPage;
        this.isPrintNP = isPrintNP;
    }

    // Track whether or not the hero is currently changing size in a transition. This is useful for adjusting the size
    // of other components on the page in response to this.
    onHeroChangingSize({ heroChangingSize }) {
        this.heroChangingSize = heroChangingSize;
        this.emitChange();
    }

    getHeroChangingSize() {
        return this.heroChangingSize;
    }

    /**
     * sets buyerAssurance state.showInfo which controls the hide/showing of the tooltip
     * @param {object}  payload
     * @param {boolean} payload.showInfo - show/hide buyer assurance tooltip/modal on pdp
     */
    onToggleBuyerAssuranceShowInfo(payload) {
        let { showInfo } = payload;

        if (showInfo === undefined) {
            showInfo = !this.buyerAssuranceProps.state.showInfo;
        }

        this.buyerAssuranceProps.state.showInfo = showInfo;
        this.emitChange();
    }

    deleteBuyerAssuranceCookie() {
        $.removeCookie('__buyerAssurance');
    }

    getBuyerAssuranceProps() {
        if (this.itemStore.isTradeReturnAvailable()) {
            this.buyerAssuranceProps.copy.tooltip = this.buyerAssuranceProps.copy.tradeTooltip;
        }

        return this.buyerAssuranceProps;
    }

    getEnableNetPrice() {
        return this.enableRequestNetPrice;
    }

    _updateEnableNetPrice({ userCanRequestNetPrice }) {
        this.enableRequestNetPrice = !!(this.isNetPriceVertical && userCanRequestNetPrice);
    }

    getIsPrintNP() {
        return this.isPrintNP;
    }

    getIsPrintPage() {
        return this.isPrintPage;
    }

    getSelectedImage() {
        return Number(this.selectedImage) || 0;
    }

    setForceFavoriteItem() {
        this.forceFavoriteItem = true;
    }

    getForceFavoriteItem() {
        return this.forceFavoriteItem;
    }

    showPinterestModal() {
        this.isPinterestModalShown = true;
        this.emitChange();
    }

    getIsPinterestModalShown() {
        return this.isPinterestModalShown;
    }
}

PdpUiStore.storeName = 'PdpUiStore';
PdpUiStore.handlers = {
    [pdpActionsConstants.ACTION_CAROUSEL_INDEX]: 'onChangeIndex',
    [pdpActionsConstants.ACTION_HERO_EXPANDED]: 'onHeroExpanded',
    [pdpActionsConstants.ACTION_SHIPPING_REQUEST_AUTHENTICATED]: 'onShippingRequestAuthenticated',
    [pdpActionsConstants.ACTION_SHIPPING_REQUEST_COMPLETED]: 'onShippingRequestCompleted',
    [pdpActionsConstants.ACTION_HERO_CHANGING_SIZE]: 'onHeroChangingSize',
    [pdpActionsConstants.ACTION_TOGGLE_BUYER_ASSURANCE_SHOW_INFO]: 'onToggleBuyerAssuranceShowInfo',
    [pdpActionsConstants.ACTION_DELETE_BUYER_ASSURANCE_COOKIE]: 'deleteBuyerAssuranceCookie',
    [loginActions.ACTION_NET_PRICE]: '_updateEnableNetPrice',
    [pdpActionsConstants.ACTION_PRINT_PAGE]: 'setPrintPage',
    [pdpActionsConstants.ACTION_FORCE_FAVORITE_ITEM]: 'setForceFavoriteItem',
    [pdpActionsConstants.ACTION_SHOW_PINTEREST_MODAL]: 'showPinterestModal',
};

module.exports = PdpUiStore;



// WEBPACK FOOTER //
// ./assets/js/newPdp/stores/PdpUiStore.es.js